<div class="d-flex justify-content-between align-items-center pb-3 mb-3 chart-header-border">
  <div class="d-flex align-items-center">
    <div class="chart-icon-container me-3">
      <i class="bi bi-bar-chart"></i>
    </div>
    <h3 class="chart-title mb-0">{{ title }}</h3>
  </div>
  <div class="d-flex align-items-center gap-2" *ngIf="totalItemsCount >= 0">
    <div class="d-flex align-items-center me-2">
      <label class="me-2 mb-0 small text-muted">Bars per page</label>
      <select class="form-select form-select-sm w-auto" [(ngModel)]="ItemsPerPage" (ngModelChange)="pageSizeChange ? pageSizeChange($event) : null">
        <option [ngValue]="5">5</option>
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
      </select>
    </div>
    <div class="small text-muted me-2">
      Showing {{ pageStartDisplay }}–{{ pageEndDisplay }} of {{ totalItemsCount }}
    </div>
    <div class="btn-group btn-group-sm" role="group" aria-label="Pagination">
      <button class="btn btn-sm btn-teal-gradient" (click)="pageChange.emit(currentPage - 1); goToPage(currentPage - 1)" [disabled]="currentPage === 1">
        <i class="bi bi-chevron-left"></i>
      </button>
      <button class="btn btn-teal-gradient" (click)="pageChange.emit(currentPage + 1); goToPage(currentPage + 1)" [disabled]="currentPage >= totalPages">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>
  </div>
</div>

<div class=" card-body p-0">
  <div class="align-items-center justify-content-center flex-fill">
    <canvas baseChart [data]="chartData" [options]="chartOptions" type="bar"></canvas>
  </div>
</div>
